<template>
  <div class="jc-page-container">
    <div class="jc-page-header">
      <el-page-header title="客户预付费详情" />
    </div>

    <div class="jc-page-content">
      <div class="jc-page-card">
        <div class="jc-section">
          <div class="jc-section-content">
            <el-form class="jc-datashow-list">
              <el-row :gutter="20">
                <el-col :span="10">
                  <el-form-item label="订单编号：">
                    <p>{{ detail.orderNumber | filterParams }}</p>
                  </el-form-item>
                </el-col>

                <el-col :span="10">
                  <el-form-item label="类型：">
                    <p>{{ detail.orderType | filterParams }}</p>
                  </el-form-item>
                </el-col>

                <el-col :span="10">
                  <el-form-item label="创建时间：">
                    <p>{{ detail.createTime | filterParams }}</p>
                  </el-form-item>
                </el-col>

                <el-col :span="10">
                  <el-form-item label="订单完成时间：">
                    <p>{{ detail.payTime | filterParams }}</p>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>

        <div class="jc-container-table">
          <el-table :data="tableData" style="width: 100%" class="form-loading">
            <el-table-column label="产品名称">
              <template slot-scope="scope">{{
                scope.row.serviceName | filterParams
              }}</template>
            </el-table-column>

            <el-table-column label="产品详情">
              <template slot-scope="scope">
                <ul>
                  <li v-for="(item, index) in scope.row.extraInfo" :key="index">
                    {{ `${item.name} ： ${item.value}` }}
                  </li>
                </ul>
              </template>
            </el-table-column>

            <el-table-column label="数量">
              <template slot-scope="scope">{{
                scope.row.quantity | filterParams
              }}</template>
            </el-table-column>

            <el-table-column label="购买时长">
              <template slot-scope="scope">{{
                `${scope.row.chargeDuration}${
                  scope.row.unit === '月' ? '个' : ''
                }${scope.row.unit}` | filterParams
              }}</template>
            </el-table-column>

            <el-table-column label="费用(元)">
              <template slot-scope="scope">{{
                scope.row.totalFee | formatMoney
              }}</template>
            </el-table-column>
          </el-table>

          <!-- <div class="jc-container-table-actionBar" v-if="total > 10">
            <jc-pagination @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="form.pageIndex"
                           :page-sizes="[10, 20, 50]"
                           :page-size="form.pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </jc-pagination>
          </div> -->
        </div>

        <div class="jc-section">
          <div class="jc-section-content">
            <div class="jc-container-order-total">
              <ul>
                <li>
                  <div class="jc-layout-table">
                    <label class="title">应付金额：</label>

                    <div class="content">
                      <span class="pay"
                        >¥ {{ detail.actualFee | formatMoney }}</span
                      >
                    </div>
                  </div>

                  <div class="jc-layout-table">
                    <label class="title">原价：</label>

                    <div class="content">
                      ¥ {{ detail.totalFee | formatMoney }}
                    </div>
                  </div>

                  <div class="jc-layout-table">
                    <label class="title">优惠金额：</label>

                    <div class="content">
                      ¥ {{ detail.discountFee | formatMoney }}
                    </div>
                  </div>

                  <div class="jc-layout-table">
                    <label class="title">代金券支付：</label>

                    <div class="content">
                      ¥ {{ detail.favorableFee | formatMoney }}
                    </div>
                  </div>

                  <div class="jc-layout-table">
                    <label class="title">现金支付：</label>

                    <div class="content">
                      ¥ {{ detail.cashTotal | formatMoney }}
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { queryCustPreFeeDetail } from '@/api/distributor-api.js'
import routerMixins from '@/mixins/router-mixins.js'
export default {
  mixins: [routerMixins],
  data() {
    return {
      orderNo: this.$route.params.id || '',
      detail: {},
      tableData: [],
    }
  },
  created() {
    this.query()
  },
  methods: {
    async query() {
      try {
        let { result } = await queryCustPreFeeDetail({
          orderNo: this.orderNo,
        })
        this.tableData =
          (result &&
            result.orderDetail &&
            result.orderDetail.orderItemDetails) ||
          []
        this.detail = result && result.orderDetail
        this.detail.cashTotal =
          Number(this.detail.moneyPay) + Number(this.detail.balancePay) || 0
      } catch (err) {
        this.tableData = []
        this.detail = {}
      }
    },
  },
}
</script>
